export default "__VITE_PUBLIC_ASSET__bdebdefc__"